import { FileViewerProps } from "./Interfaces/FileViewer.interfaces";

const getEmbedUrl = (fileType: string, fileUrl: string): string => {
  const fileEmbedSrc = fileUrl.includes(window.location.origin) ? fileUrl : `${window.location.origin}${fileUrl}`;

  if (["docx", "pptx"].includes(fileType)) {
    return `https://view.officeapps.live.com/op/embed.aspx?src=${fileEmbedSrc}`;
  }
  return fileUrl;
};

const RenderFrame = ({ fileType, fileUrl, frameStyle }: FileViewerProps) => {
  const embedUrl = getEmbedUrl(fileType, fileUrl);

  return (
    <iframe
      src={embedUrl}
      style={frameStyle}
      title={`${fileType.toUpperCase()}-Viewer`}
      sandbox="allow-forms allow-same-origin allow-scripts"
    />
  );
};

export const FileViewer = ({ fileType, fileUrl, frameStyle }: FileViewerProps) => (
  <RenderFrame fileType={fileType} fileUrl={fileUrl} frameStyle={frameStyle} />
);
